/** Top.Mail.Ru / VK Ads pixel counter ID */
export const VK_PIXEL_ID = '3771802';

/** Custom conversion goal names — create matching goals in VK Ads cabinet */
export const VK_GOALS = {
    PORTAL_REGISTER: 'portal_register',
    PORTAL_LOGIN: 'portal_login',
    CHECKER_START: 'checker_start',
    CHECK_SUBMIT: 'check_submit',
};

function getTmrQueue() {
    if (typeof window === 'undefined') return null;
    window._tmr = window._tmr || [];
    return window._tmr;
}

/** SPA route change — base pageView is sent from index.html on first load */
export function trackVkPageView() {
    const tmr = getTmrQueue();
    if (!tmr) return;
    tmr.push({ id: VK_PIXEL_ID, type: 'pageView', start: new Date().getTime() });
}

/** Custom conversion event for VK Ads optimization */
export function trackVkGoal(goal) {
    if (!goal) return;
    const tmr = getTmrQueue();
    if (!tmr) return;
    tmr.push({ id: VK_PIXEL_ID, type: 'reachGoal', goal });
}

const ROUTE_GOALS = {
    '/portal/checker': VK_GOALS.CHECKER_START,
};

export function trackVkRouteGoals(pathname) {
    const goal = ROUTE_GOALS[pathname];
    if (goal) trackVkGoal(goal);
}
